<template>
  <el-drawer :visible.sync="show" size="560px" :withHeader="false" :modal="true" :direction="direction"
    :wrapperClosable="wrapperClosable" :before-close="handleClose" class="project-task-detail">
    <div v-if="show" v-loading="loading" class="flex column">
      <div class="bd header">
        <task-bread :project_task_path="detail.location" />
        <CommonMore :show="true" :list="commonConfig()" @change="handleCommonChange(detail, $event)" />
      </div>
      <div class="bd container">
        <!-- 标题 -->
        <div class="flex align-items-center">
          <el-checkbox v-model="titleStatus" :disabled="!(tmpUser.permission==1||tmpUser.uid == detail.principal)">
          </el-checkbox>
          <div class="detail-title-box ml-xs">
            <el-input v-model="detail.task_title" :disabled="!(tmpUser.permission==1||tmpUser.uid == detail.principal)"
              class="detail-title-input" ref="titleInput" maxlength="60" @keydown.enter.native="titleKeydown"
              @blur="handleUpdateTitle" />
          </div>
        </div>
        <!-- 时间、负责人 -->
        <div class="flex justify-content-space-between align-items-center mt">
          <div class="flex align-items-center">
            <!-- <span class="icon-container flex-center">
              <i class="el-icon-date text-muted"></i>
            </span> -->
            <common-date-picker v-model="detail.starttime" width='120px' type="date" format="yyyy-MM-dd"
              :disabled="!(tmpUser.permission==1||tmpUser.uid == detail.principal)" prefix-icon="el-icon-date"
              clear-icon="el-icon-circle-close" placeholder="开始时间"
              :picker-options="{disabledDate:(date=>{return date < detail.endtime})}" class="task-time-picker-calss"
              need-show @change="handleStarttime">
            </common-date-picker>
            <common-date-picker v-model="detail.endtime" width='120px' type="date" format="yyyy-MM-dd"
              :picker-options="{disabledDate:(date=>{return date > detail.starttime})}"
              :disabled="!(tmpUser.permission==1||tmpUser.uid == detail.principal)" prefix-icon="el-icon-date"
              clear-icon="el-icon-circle-close" placeholder="结束时间" class="task-time-picker-calss" need-show
              @change="handleEndtime">
            </common-date-picker>
          </div>
            
          <member-selector :uid="detail.principal ? detail.principal : null" enabled
            :disabled="!(tmpUser.permission==1||tmpUser.uid == detail.principal)" @change="handlePrincipalChange">
            <template slot="default">
              <div class="flex align-items-center principal-item">
                <span v-if="!detail.principal" class="icon-container flex-center">
                  <i class="el-icon-user"></i>
                </span>
                <f-user-avatar v-else
                  :user="{uid:detail.principal,avatar:detail.principal_avatar,username:detail.principal_username}" />
                <span v-if="detail.principal" role="button" class="flex align-items-center principal ellipsis ml-xs">
                  <span class="ml-xs">{{ detail.principal_username }}</span>
                </span>
                <span v-if="!detail.principal" role="button" class="text-muted principal-default ml-xs">设置负责人</span>

                <div class="flex-center ml-xs" style="min-width:14px">
                  <i class="el-icon-close" role="button" @click.stop="removePrincipal"></i>
                </div>
              </div>
            </template>
          </member-selector>

        </div>
        <span class="line mt-lg mb-lg"></span>
        <!-- 状态、优先级 -->
        <div class="flex justify-content-space-between align-items-center">
          <div class="flex align-items-center">
            <span class="text-muted mr-sm">
              <i class="el-icon-circle-check"></i>
              <span class="ml-xs">状态</span>
            </span>
            <span role="button" class="status flex align-items-center pl-xs" @click="handleStatusShow">
              <StatusSelector :value="detail.status" enabled  :transfer="false"
                :disabled="!(tmpUser.permission==1||tmpUser.uid == detail.principal)" size="small" ref="statusRef"
                class="status-selector" @change="handleStatusChange">
              </StatusSelector>
            </span>

          </div>
          <div class="flex align-items-center">
            <span class="text-muted mr-sm">
              <i class="el-icon-d-arrow-left"></i>
              <span class="ml-xs">优先级</span>
            </span>
            <div role="button" class="priority flex align-items-center pl-xs" @click="handlePriorityShow">
              <PrioritySelector :value="detail.priority"  :transfer="false"
                :disabled="!(tmpUser.permission==1||tmpUser.uid == detail.principal)" enabled size="small"
                ref="priorityRef" class="priority-selector" @change="handlePriorityChange">
                <span v-if="detail.priority == 0" slot="none"><i
                    class="el-icon-plus text-muted add-icon text-bold"></i></span>
              </PrioritySelector>
            </div>
          </div>
        </div>
        <!-- 备注 -->
        <div class="flex mt-lg">
          <span style="margin-top: 6px" class="text-muted">
            <i class="el-icon-edit"></i>
            <span class="ml-xs">备注</span>
          </span>
          <span v-if="!isTextAreaEdit" style="width: calc(100% - 57px)" class="detail-empty ml-sm"
            :class="detail.remark && 'detail-remark-noempty'" @click="handleShowTextarea">
            <i v-if="!detail.remark" class="el-icon-plus text-muted add-icon"></i>
            <span>{{ detail.remark }}</span>
          </span>
          <el-input v-if="isTextAreaEdit" type="textarea"
            :disabled="!(tmpUser.permission==1||tmpUser.uid == detail.principal)" ref="remarkTextRef" :rows="5"
            placeholder="" v-model="detail.remark" class="detail-remark-textarea ml-sm"
            @keydown.enter.native="isTextAreaEdit = false" @blur="handleTextareaChange">
          </el-input>
        </div>
        <span class="line mt-lg mb-lg"></span>
        <!-- 子任务 -->
        <div class="flex column">
          <div class="hd">
            <span class="mr-sm text-bold">子任务</span>
            <span class="text-muted">{{ childTaskFinishNum }}/{{ detail.child_task && detail.child_task.length }}</span>
          </div>
          <div class="bd mt">
            <task-item v-for="(item, index) in detail.child_task" :key="'task' + item.taskid" :task="item"
              :ref="'taskitem' + index" :ptaskid="detail.taskid"
              :showEdit="tmpUser.permission == 1|| tmpUser.uid == item.principal" @delete="deleteTask(item,index)"/>

              <task-item v-if="tmpTask" :task="tmpTask"
              ref="taskTmp" :ptaskid="tmpTask.taskid" @change="addTaskChange"/>
          </div>
          <div class="ft">
            <div class="detail-empty pointer" @click="handleShowAddTask">
              <i class="el-icon-plus text-muted add-icon"></i>
            </div>
          </div>
        </div>
        <span class="line mt-lg mb-lg"></span>
        <!-- 附件 -->
        <div class="flex column">
          <div class="hd">
            <span class="text-bold">附件</span>
          </div>
          <div class="bd mt">
            <div v-for="item in detail.follower" :key="item.id" class="file-item flex align-items-center mb-sm">
              <span class="hd">
                <img :src="item.icon" alt="" class="image xs" />
              </span>
              <span style="max-width: 360px" class="bd ellipsis pl-sm">
                {{ item.task_title }}
              </span>
              <span class="ft">
                <i role="button" class="el-icon-download operate-icon font-md ml-lg"></i>
                <i role="button" class="el-icon-delete operate-icon font-md ml"></i>
              </span>
            </div>
          </div>
          <div class="ft">
            <upload ref="upload" class="upload-demo" style="width: 100%" action=""
              :disabled="!(tmpUser.permission==1||tmpUser.uid == detail.principal)"
              :data="{ taskid: detail.taskid, projectid: detail.projectid }" :multiple="true" :on-change="hangdleChange"
              :before-remove="handleBeforeRemove" :on-success="handleSuccess" :file-list="fileList"
              :upload-style="{ width: '100%' }">
              <div class="detail-empty pointer">
                <i class="el-icon-plus text-muted add-icon"></i>
              </div>
            </upload>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>

import { getTaskDetailApi, updateTaskApi } from '@/api/pm/taskApi'
import { getAccessToken } from "@/utils/cookie";
import { finishUpload, deleteFile } from "@/api/pm/mfgApi"

import store from '@/store/store'
export default {
  name: 'TaskDetail',

  components: {
    CommonMore: () => import('../common/CommonMore'),
    MemberSelector: () => import('../common/MemberSelector.vue'),
    PrioritySelector: () => import('../common/CommonPrioritySelector'),
    StatusSelector: () => import('../common/CommonStatusSelector'),
    TaskItem: () => import('./components/taskItem.vue'),
    Upload: () => import('./upload/index'),
    TaskBread: () => import('./components/TaskBread.vue'),
    CommonDatePicker: () => import('../common/CommonTimePicker.vue')
  },

  data () {
    return {
      show: false,
      loading: false,
      uploadCenterShow: false,
      principalShow: false, // 负责人选择器显隐
      priorityShow: false, // 优先级选择器显隐
      statusShow: false, // 任务状态选择器显隐
      wrapperClosable: true,
      direction: 'rtl',
      store: store,
      AccessToken: getAccessToken(),
      isTextAreaEdit: false,
      isAddTaskEdit: false,
      activeid: '',
      taskid: null,
      detail: {},

      timeOpts: [-30, -7, -1, 0, 1, 7, 30],
      newTask: {},
      fileList: [],

      tmpTask: null
    }
  },

  computed: {
    titleStatus: {
      get () {
        return this.detail.status == 2 ? true : false
      },
      set (v) {
        if (v) {
          this.detail.status = 2
        } else {
          this.detail.status = 1
        }
        return v
      }
    },
    childTaskFinishNum () {
      return Object.keys(this.detail).length && this.detail.child_task.length ? this.detail.child_task.filter(v => v.status == 100).length : 0
    },
    commonConfig () {
      return function () {
        return [
          {
            name: '删除任务',
            command: 'delete',
            type: 'danger'
          }
        ]
      }
    },
    tmpUser () {
      return store.state.middleStore.TeamMember.find(item => {
        return item.uid == store.state.userStore.user.uid
      })
    }

  },

  mounted () {
  },

  watch: {
    detail (val) {
    }
  },

  methods: {
    open (id) {
      this.show = true
      this.taskid = id
      this.fetchData()
    },

    fetchData (arr) {
      if (!arr) this.loading = true
      getTaskDetailApi({ taskid: this.taskid }).then(res => {
        this.loading = false
        if (!res.errno) {
          this.detail = res.data
          this.fileList = res.data.files
        } else {
          this.$message.error(res.message)
        }
      })
    },

    checkAllow () {
      console.log(!(this.tmpUser.permission == 1 || this.tmpUser.uid == this.detail.principal), this.tmpUser.permission, this.tmpUser.uid, this.detail.principal);
      if (!(this.tmpUser.permission == 1 || this.tmpUser.uid == this.detail.principal)) {
        this.$message.error('无权限')
        this.fetchData()
        return true
      } else {
        return false
      }
    },

    handleStarttime (start) {
      if (this.checkAllow()) {
        return
      }
      updateTaskApi(Object.assign({}, this.detail, { starttime: start })).then(res => {
        if (!res.errno) {
          store.dispatch('getAllProjectCardTask')
        } else {
          this.$message.error(res.message)
        }
        this.fetchData()
      })
    },
    handleEndtime (end) {
      if (this.checkAllow()) {
        return
      }
      updateTaskApi(Object.assign({}, this.detail, { endtime: end })).then(res => {
        if (!res.errno) {
          store.dispatch('getAllProjectCardTask')
        } else {
          this.$message.error(res.message)
        }
        this.fetchData()
      })
    },
    updateTaskDetail () {
      updateTaskApi(this.detail).then(res => {
        if (!res.errno) {
          store.dispatch('getAllProjectCardTask')
        } else {
          this.$message.error(res.message)
        }
        this.fetchData()
      })
    },

    // 负责人处理
    handlePrincipalChange (e) {
      if (this.checkAllow()) {
        return
      }
      // this.principalShow = false
      this.detail = Object.assign(this.detail, {
        principal: e && e.uid,
        principal_avatar: e && e.avatar,
        principal_username: e && e.username
      })
      this.updateTaskDetail()
    },

    removePrincipal () {
      this.detail = Object.assign(this.detail, {
        principal: null,
        principal_avatar: '',
        principal_username: ''
      })
      this.updateTaskDetail()
    },

    // 任务状态处理
    handleStatusShow () {
      this.statusShow = true
    },
    handleStatusChange (e) {
      if (this.checkAllow()) {
        return
      }
      if (e != undefined) {
        this.statusShow = false
        this.detail.status = e
        this.updateTaskDetail()
      }
    },

    // 优先级处理
    handlePriorityShow () {
      this.priorityShow = true
    },
    handlePriorityChange (e) {
      if (this.checkAllow()) {
        return
      }
      if (e != undefined) {
        this.priorityShow = false
        this.detail.priority = e
        this.updateTaskDetail()
      }
    },

    // 标题处理
    titleKeydown (e) {
      e.preventDefault()
      e.target.blur()
    },
    handleUpdateTitle () {
      if (this.checkAllow()) {
        return
      }
      this.updateTaskDetail()
    },

    // 备注
    handleShowTextarea () {
      if (this.checkAllow()) {
        return
      }
      this.isTextAreaEdit = true
      this.$nextTick(() => {
        this.$refs['remarkTextRef'].focus()
      })
    },
    handleTextareaChange () {
      this.isTextAreaEdit = false
      this.updateTaskDetail()
    },

    // 子任务状态处理
    handleChildTaskStatusChange () {
      if (this.checkAllow()) {
        return
      }
      this.updateTaskDetail()
    },

    async handleShowAddTask () {
      if (this.tmpUser.permission == 3) {
        this.$message.error('无权限!')
        return
      }
      this.tmpTask = {
        task_title: '',
        status: 0,
        principal: null,
        priority: 0,
        starttime: null,
        endtime: null,
        createtime: parseInt(+new Date() / 1000),
        remark: '',//校验有问题
        ptaskid: this.detail.taskid,
        projectid: this.detail.projectid,
        before_taskid: this.detail.child_task && this.detail.child_task.length ? this.detail.child_task[this.detail.child_task.length - 1].taskid : null
      }
    },

    addTaskChange (task) {
      if (task)
        this.detail.child_task.push(task)
      this.tmpTask = null
    },

    handleBlurTask () {
      if (this.tmpUser.permission == 3) {
        this.$message.error('无权限!')
        return
      }
      updateTaskApi(this.newTask).then(res => {
        store.dispatch('getAllProjectCardTask')
        this.isAddTaskEdit = false
        this.fetchData()
      })
    },

    handleShowAddFile () {
      this.uploadCenterShow = !this.uploadCenterShow
    },

    handleClose (done) {
      this.tmpTask = null
      done()
    },

    /** 更多操作回调处理 */
    handleCommonChange (row, e) {
      if (e == 'delete') {
        this.deleteTask(row)
      }
    },

    deleteTask (task, index) {
      this.detail.child_task.splice(index, 1)
    },

    hangdleChange (file, fileList) {
      this.fileList = fileList
    },
    async handleBeforeRemove (file, flist) {
      if (this.checkAllow()) {
        return false
      }
      let stt = this.$confirm(`确定要删除名为<span class="text-danger">【${file.name}】</span>附件么？`, '删除附件', {
        dangerouslyUseHTMLString: true,
        closeOnClickModal: false,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'confirm-danger-class'
      })
      return new Promise((resolve, reject) => {
        stt.then(() => {
          deleteFile({ fileid: file.fileid }).then(res => {
            if (!res.errno) {
              this.$message.success('删除成功！')
              resolve(true)
            } else {
              this.$message.error(res.message)
              reject(false)
            }
          }).catch(() => {
            reject(false)
          })
        })
      })

    },
    handleSuccess (res, file, filelist) {
      let end = res.res.requestUrls[0].indexOf('?')
      let path = ''
      if (end > -1) {
        path = res.res.requestUrls[0].substring(0, end)
      } else {
        path = res.res.requestUrls[0]
      }
      finishUpload({
        projectid: this.detail.projectid,
        taskid: this.detail.taskid,
        name: res.name,
        ext: file.name.slice(file.name.lastIndexOf('.')),
        size: file.size,
        path
      }).then(res => {
        this.fetchData()
      })
    }

  }
}
</script>

<style lang="scss">
$active-color: #07c160;
$hover-bg: #f5f7fa;
$icon-color: #999999;
$border-color: #e7e7e7;

@keyframes slide {
  0% {
    left: -150px;
  }

  100% {
    left: 600px;
  }
}

.project-task-detail {
  .el-drawer__body {
    .header {
      border-bottom: 1px solid $border-color;
      padding: 15px 20px;
      position: sticky;
      top: 0;
      left: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #fff;
      z-index: 99;
      box-shadow: 0 8px 30px 0 rgba(0, 0, 0, 0.03);
    }

    .line {
      width: 100%;
      height: 1px;
      background-color: $border-color;
    }

    .container {
      padding: 15px 20px;
      display: flex;
      flex-direction: column;

      .detail-title-box {
        width: calc(100% - 5px);

        .detail-title-input {
          width: 100%;
          margin-bottom: 1px;

          input {
            font-size: 18px;
            font-weight: 600;
            border: 1px solid rgba(0, 0, 0, 0);
            padding: 3px 5px;
            cursor: text;
            color: #010101;
            background: #ffffff;
            width: 100%;
            border-radius: 5px;
            resize: none;

            &:focus {
              border: 1px solid $active-color;
              background-color: #fff;
            }
          }

          &:hover {
            input {
              background-color: $hover-bg;

              &:focus {
                border: 1px solid $active-color;
                background-color: #fff;
              }
            }
          }
        }
      }

      .icon-container {
        width: 40px;
        height: 40px;
        padding: 5px;
        font-size: 18px;
        border-radius: 50%;
        border: 1px dashed $icon-color;
      }

      .task-time-picker-calss {
        .el-date-editor {
          .el-input__prefix {
            font-size: 18px;
          }
        }

        &:hover {
          .el-date-editor {
            .el-input__prefix {
              color: #409eff;
            }

          }


        }

        .date-picker {
          /deep/.el-input_prefix {
            padding: 5px;
            font-size: 18px;
            border-radius: 50%;
            border: 1px dashed $icon-color;
          }
        }
      }

      .principal-item {
        .el-icon-close {
          display: none;
        }

        &:hover {
          .el-icon-close {
            display: inline-block;

            &:hover {
              color: $active-color;
            }
          }
        }
      }

      .principal {
        width: 185px;
        padding: 4px 8px;

        &:hover {
          border-radius: 5px;
          background-color: $hover-bg;
        }
      }

      .principal-default {
        width: 185px;
        height: 32px;
        padding-left: 8px;
        line-height: 32px;

        &:hover {
          border-radius: 5px;
          background-color: $hover-bg;
        }
      }

      .status,
      .priority {
        width: 180px;
        height: 32px;
        background-color: $hover-bg;
        border-radius: 5px;
        border: 1px solid rgba(0, 0, 0, 0);

        &:hover {
          border: 1px solid $border-color;
        }
      }

      .priority-selector,
      .status-selector {
        width: 180px;

        .arrow-show {
          display: none;
        }

        &:hover {
          .arrow-show {
            display: inline-block;
          }
        }
      }

      .detail-status-select,
      .detail-level-select {
        width: 180px;
        position: relative;

        .add-icon {
          position: absolute;
          top: 50%;
          left: 5px;
          transform: translate3d(0, -50%, 0);
        }

        .el-input.el-input--small {
          font-size: 15px;

          .el-input__inner {
            padding-left: 5px;
            border: 1px solid rgba(0, 0, 0, 0);
            background-color: $hover-bg;

            &:focus {
              border: 1px solid $active-color;
              background-color: #fff;

              &:hover {
                border: 1px solid $active-color;
              }
            }

            &:hover {
              border: 1px solid $border-color;
            }
          }

          &.is-focus {
            .add-icon {
              display: none;
            }
          }

          .el-input__suffix {
            opacity: 0;
          }
        }
      }

      .detail-empty {
        cursor: text;
        font-size: 16px;
        padding: 5px 10px;
        width: 100%;
        min-height: 32px;
        border-radius: 3px;
        position: relative;
        border: 1px solid rgba(0, 0, 0, 0);
        transition: all 0.2s;
        background-color: $hover-bg;

        &:hover {
          border: 1px solid $border-color;
        }

        .add-icon {
          position: absolute;
          top: 50%;
          left: 10px;
          transform: translate3d(0, -50%, 0);
        }
      }

      .detail-remark-noempty {
        background-color: #fff;
        border: 1px solid #f6f6f6;
      }

      .detail-remark-textarea {
        transition: all 0.2s;
        width: calc(100% - 57px);

        textarea {
          padding-left: 10px;
          padding-right: 10px;
        }
      }

      .sub-task-title {
        max-width: 360px;

        &:hover {
          color: $active-color;
        }
      }

      .sub-task-item,
      .file-item {
        position: relative;
        font-size: 12px;
        height: 32px;
        padding: 5px 30px 5px 10px;
        border-radius: 3px;
        background-color: $hover-bg;
        border: 1px solid rgba(0, 0, 0, 0);

        .operate-icon {
          padding: 3px;
          border-radius: 3px;
          display: none;
        }

        .slide-animate {
          position: absolute;
          left: -9999px;
          // left: 0;
          top: 0;
          width: 100px;
          height: 2px;
          filter: blur(30px);
          background-color: $active-color;
          animation: slide 0.8s 1;
        }

        &:hover {
          border: 1px solid $border-color;

          .operate-icon {
            display: inline-block;

            &:hover {
              background-color: #eee;
            }
          }
        }
      }

      .task-is-edit {
        height: 32px;
        border-radius: 3px;
        border: 1px solid $active-color;
        display: flex;
        align-items: center;

        .el-input.el-input--small {
          max-width: 360px;

          .el-input__inner {
            height: 30px;
            border: 1px solid rgba(0, 0, 0, 0);
          }
        }
      }

      .pointer {
        cursor: pointer;
      }
    }

    // checkbox样式
    .el-checkbox {
      .el-checkbox__input {
        .el-checkbox__inner {
          border-radius: 50%;
        }
      }
    }

    .common-tag {
      // color: #fff;
      border-radius: 30px;
      padding: 3px 12px;
    }

    .common-tag.level-low {
      background-color: #07c160;
    }

    .common-tag.level-middle {
      background-color: #409eff;
    }

    .common-tag.level-hight {
      background-color: #f56c6c;
    }
  }
}
</style>